const trendingFormatter = (number) => {
    if (number < 0) {
        return number.toFixed(0);
    } else if (number < 10) {
        return number.toFixed(1);
    } else if (number < 1000) {
        return Math.floor(number).toString();
    } else if (number < 10000) {
        return (Math.floor(number / 100) / 10).toFixed(1) + 'K';
    } else if (number < 1000000) {
        return Math.floor(number / 1000) + 'K';
    } else if (number < 10000000) {
        return (Math.floor(number / 100000) / 10).toFixed(1) + 'M';
    } else {
        return Math.floor(number / 1000000) + 'M';
    }
};

export {trendingFormatter};